<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
					<div class="col-lg-4">
						<label >Nombre del Proyecto *</label>
                        <input type="text" v-model="Proyecto.Nombre" class="form-control" placeholder="Nombre" id="Nombre" name="Nombre" />
                        <Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
					</div>
					<div class="col-lg-4">
						<label>Cliente</label>
                        <treeselect
                            :options="ListaClientes"
                            placeholder="Cliente..."
                            v-model="Proyecto.IdCliente"
                            @input="ImagenPredeterminada();GetListaPropiedades()"
							:disable-fuzzy-matching="true"
                        />
					</div>
					<div class="col-lg-4">
						<label>Propiedad</label>
                        <treeselect
                            :options="ListaPropiedades"
                            placeholder="Propiedad..."
                            v-model="Proyecto.IdClienteS"
                            @input="ImagenPredeterminada();GetListaContratos()"
							:disable-fuzzy-matching="true"
                        />
					</div>
                </div>
				<div class="row mt-3">
					<div class="col-lg-4">
						<label>Contrato</label>
                        <treeselect
                            :options="ListaContratos"
                            placeholder="Contrato..."
                            v-model="Proyecto.IdContrato"
							@input="SeleccionContrato();SeleccionContratoMontos()"
							:disable-fuzzy-matching="true"
                        />
					</div>
					<!-- <div class="col-lg-4">
						<label for="">Aditivas</label>
                        <treeselect
						:multiple="true"
                            :options="ListaContratosAditiva"
                            placeholder="Contratos..."
                            v-model="Proyecto.ContratosAditiva"
							:disable-fuzzy-matching="true"
                        />
					</div> -->
					<div class="col-lg-4" v-show="Proyecto.ProjectManager!='' && Proyecto.ProjectManager!=null">
						<label for="">Project Manager</label>
						<input type="text" v-model="Proyecto.ProjectManager" class="form-control">
					</div>
					<div class="col-lg-4" v-show="Proyecto.IdProjectManager!=null || Proyecto.IdProyecto==0">
						<label for="">Project Manager</label>
						<select v-model="Proyecto.IdProjectManager" class="form-control">
							<option value="">-Project Manager-</option>
							<option v-for="(item,index) in ListProjectManager" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
						</select>
					</div>
					<div class="col-lg-4" v-show="Proyecto.Residente!=null && Proyecto.Residente!=''">
						<label>Residente</label>
						<input type="text" class="form-control" v-model="Proyecto.Residente">
					</div>
					<div class="col-lg-4" v-show="Proyecto.IdResidente!=null || Proyecto.IdProyecto==0">
						<label>Residente</label>
						<select v-model="Proyecto.IdResidente" class="form-control">
							<option value="">-Residente-</option>
							<option v-for="(item,index) in ListResidente" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
						</select>
						<!-- <input type="text" class="form-control" v-model="Proyecto.Residente"> -->
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-4">
						<label for="">Ciudad</label>
						<input type="text" v-model="Proyecto.Ciudad" class="form-control">
					</div>
					<div class="col-lg-8">
						<label>Dirección</label>
                        <input type="text" v-model="Proyecto.Direccion" class="form-control" placeholder="Direccion" id="Direccion" name="Direccion" />
                        <Cvalidation v-if="this.errorvalidacion.Direccion" :Mensaje="errorvalidacion.Direccion[0]"></Cvalidation>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-4">
                        <div class="avatar-upload">
                            <div class="avatar-edit">
                                <input
									id="imagen"
									ref="imagen"
									type="file"
									name="imagen"
									@change="CambiarImagen($event)"
									accept=".png, .jpg, .jpeg"
								/>
								<label for="imagen"></label>
                            </div>
                            <div class="avatar-preview">
                                <div
                                    id="imagePreview"
                                    style="background-image: url(Img);"
                                ></div>
                            </div>
                        </div>
                    </div>
					<div class="col-lg-8">
						<div class="row">
							<div class="col-lg-4">
								<label for="">Inicio *</label>
                        		<v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="Proyecto.FechaInicio" :mode="typeCalendar"
				        			:popover="{
				        				placement: 'bottom',
				        				visibility: 'click'
				        			}"
				        			:input-props="{
				        				class: 'form-control cal-black',
				        				style: 'cursor:pointer;'
				        			}"
				        		/>
                        		<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaInicio" :Mensaje="this.errorvalidacion.FechaInicio[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-4">
								<label for="">Termino *</label>
                        		<v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="Proyecto.FechaFin" :mode="typeCalendar"
				        			:popover="{
				        				placement: 'bottom',
				        				visibility: 'click'
				        			}"
				        			:input-props="{
				        				class: 'form-control cal-black',
				        				style: 'cursor:pointer;'
				        			}"
				        		/>
                        		<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaFin" :Mensaje="this.errorvalidacion.FechaFin[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-4">
								<label>Estatus</label>
                        		<select v-model="Proyecto.Estatus" class="form-control">
									<option value="">-Estatus-</option>
									<option value="1">Activo</option>
									<option value="2">Inactivo</option>
									<option value="3">Pausado</option>
									<option value="4">Cerrado</option>
								</select>
								<Cvalidation v-if="this.errorvalidacion.Estatus" :Mensaje="errorvalidacion.Estatus[0]"></Cvalidation>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-4">
								<label>Valor Venta</label>
								<vue-numeric
									:disabled="true"
                        		    class="form-control "
                        		    currency="$"
                        		    separator=","
                        		    placeholder="$0"
                        		    :precision="0"
                        		    v-model="Proyecto.ValorVenta"
                        		></vue-numeric>
							</div>
							<div class="col-lg-4">
								<label>Gross Profit</label>
								<vue-numeric
									:disabled="true"
                        		    currency-symbol-position="suffix"
									class="form-control "
                        		    currency="%"
                        		    separator=""
                        		    placeholder="0%"
                        		    :precision="0"
                        		    v-model="Proyecto.GrossProfit"
                        		></vue-numeric>
							</div>
							<div class="col-lg-4">
								<label>Utilidad Estimada</label>
								<vue-numeric
                        		    currency-symbol-position="suffix"
									class="form-control "
                        		    currency="%"
                        		    separator=""
                        		    placeholder="0%"
                        		    :precision="0"
                        		    v-model="Proyecto.UtilidadEstimada"
                        		></vue-numeric>
								<Cvalidation v-if="this.errorvalidacion.UtilidadEstimada" :Mensaje="errorvalidacion.UtilidadEstimada[0]"></Cvalidation>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-lg-4 pr-0 mr-0">
								<label>Fondo Retención / Garantía</label>
								<vue-numeric
									currency-symbol-position="suffix"
                        		    class="form-control "
                        		    currency="%"
                        		    separator=""
                        		    placeholder="0%"
                        		    :precision="0"
                        		    v-model="Proyecto.Fondo"
                        		></vue-numeric>
							</div>
							<div class="col-lg-3 pr-0 mr-0 pt-3">
								<label for="">Secundario</label>
								<br>
								<div class="form-check form-check-inline">
									<label class="check_box ml-3">
										<input type="checkbox" v-model="Proyecto.Branch" class="form-check-input">
										<span class="checkmark checksecundario" style="width:40px;height:40px;border:2px solid #CCCCCC"></span> 
										<!-- <span class="bold" style="position:relative;bottom:5px;font-size:16px">Secundario</span> -->
									</label>								
								</div>
							</div>
							<div v-show="Proyecto.Branch===true" class="col-lg-5 mt-3">
								<label for="">Contrato Primario</label>
								<select @change="SeleccionProyectoMaster" v-model="Proyecto.IdContratoMaster" class="form-control">
									<option value="">-Primario-</option>
									<option v-for="(item,index) in ListaContratosUsados" :key="index" :value="item.IdContrato">{{item.NumeroC}}</option>
								</select>
							</div>
						</div>
						<!-- <div class="row">
							<div class="col-lg-6">
								<label>Residente</label>
								<input type="text" class="form-control" v-model="Proyecto.Residente">
							</div>
						</div> -->
					</div>
				</div>
                <!-- <div class="row mt-3">
                    <div class="col-lg-4 d-flex">
                        <div class="avatar-upload-logocliente">
                            <div class="avatar-preview">
                                <div id="ImagePreviewLogo" :style="'background-image:url('+Proyecto.Imagen+');background-size:contain'" :src="Proyecto.Imagen">
                                    <div class="d-flex h-100 align-items-center justify-content-center" v-if="AltLogoContacto">
                                        <h4>Logo</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-1 pl-0 ml-0">
                        <label title="Seleccionar Imagen" for="imagen" style="cursor:pointer" class="btn-icon mb-2"><i class=" mt-2 fa fa-pencil"></i></label>
                        <input @change="CambiarImagen($event)" class="d-none" type="file" id="imagen" ref="imagen" name="imagen" accept=".png, .jpg, .jpeg">
                        <br>
                        <button @click="EliminarImagen" class="btn-icon-02"><i class="fa fa-trash"></i></button>
                    </div>
                </div> -->
                <div class="row mt-4">
                    <!-- <div class="col-lg-6">
                        <label for="">Seleccione la Ubicación del Proyecto</label>
                        <Search v-if="ShowMap" :oLatLng="oLatLng" :pOrigen="'proyecto'"></Search>
                    </div> -->
					<div class="col-lg-12">
						<div class="row">
							<div class="col-lg-7">
								<label class="ml-3 h3" for="">Porcentaje de Programa de Obra</label>
							</div>
							<div class="col-lg-5 d-flex justify-content-end">
								<button @click="AddPorcentajePrograma" class="btn btn-pink mr-2"><i class="fa fa-plus-circle"></i></button>
							</div>
						</div>
						<!-- <div class="form-group form row mt-2">
							<div class="col-lg-3">
								<label class="ml-3" for="">%</label>
							</div>
							<div class="col-lg-8">
								<label class="ml-1" for="">Título</label>
							</div>
						</div> -->
						<div class="row">
							<div v-for="(item,index) in PorcentajesPrograma" class="col-lg-6 mt-3" :key="index">
								<div class="row">
									<div class="col-lg-3">
									<!-- <input type="text" class="form-control" v-model="item.Porcentaje"/> -->
										<vue-numeric @keyup.native="CalcularTotalPorcentaje(index)" class="form-control text-center bold" currency="%" separator="," :precision="0" v-model="item.Porcentaje" placeholder="0%" :currency-symbol-position="'suffix'"/>
									</div>
									<div class="col-lg-8 pl-0">
										<input :disabled="!item.BndEdit" type="text" class="form-control" v-model="item.Titulo" placeholder="Título"/>
									</div>
									<div class="col-lg-1 p-0">
										<button v-show="item.BndEdit===true" @click="DeletePorcentajePrograma(index)" type="button" class="btn-icon-02 mr-2"><i class="fa fa-trash"></i></button>
									</div>
								</div>
								
							</div>
						</div>
						
					</div>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
import Config from "@/helpers/VarConfig.js";
import CLoader from "@/components/CLoader.vue";
export default {
    name:'Form',
    props:['Id','poBtnSave','pRutaImagenCliente','pRutaImagenPropiedad'],
    components:{
        Cbtnsave,
        Cvalidation,
        CLoader
    },
    data() {
        return {
            Modal:true,
            FormName:'proyecto',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ValidElement:Config.validImage2m,
            Proyecto:{
                IdProyecto:0,
                IdEmpresa:"",
                IdSucursal:"",
                IdCliente:null,
                IdClienteS:null,
				IdContrato:null,
				Residente:'',
				ContratosAditiva:[],
                Nombre:"",
                Valor:"",
                Direccion:"",
				Ciudad:"",
				ProjectManager:"",
				Estatus:"",
                Latitud:"", 
                Longitud:"",
                FechaInicio:"",
                FechaFin:"",
                Imagen:"",
				ValorVenta:"",
				GrossProfit:'',
				UtilidadEstimada:'',
				Fondo:'',
				Branch:false,
				IdProyectoMaster:'',
				IdContratoMaster:'',
				IdProjectManager:'',
				IdResidente:''
            },
            urlApi:"proyectos/recovery",
            errorvalidacion:[],
            Ruta:"",
			Contador:0,
            // RutaImagenCliente:"",
            // RutaImagenPropiedad:"",
            oBtnSave:{
                isModal:true,
                disableBtn:false,
                toast:0,
            },
            ConfigLoad:{
                ShowLoader: false,
				ClassLoad:  true,
            },
            ListaClientesNormal:[],
            ListaClientes:[],
            ListaPropiedadesNormal:[],
			ListaContratos:[],
			ListaContratosAditiva:[],
            ListaPropiedades:[],
            AltLogoContacto:true,
            ShowMap:false,
            IdClienteS:null,
			IdContrato:null,
            oLatLng:{
                Lat:null,
                Lng:null
            },
            ImagenRecuperada:false,
			ListaContratosNormal:[],
			ListaContratosUsados:[],
			PorcentajesPrograma:[],
			PorcentajesProgramaAntiguo:[],
			ListProjectManager:[],
			ListResidente:[]
        }
    },
    methods: {
		GetListPM(){
			this.$http.get('trabajadorproyecto/get').then((res)=>{
				this.ListProjectManager=res.data.data.trabajador.filter((value) => {
					if (value.IdPerfil=="12") {
						return true;
					}
					else{
						return false;
					}
				});
				this.ListResidente=res.data.data.trabajador.filter((value) => {
					if (value.IdPerfil=="13") {
						return true;
					}
					else{
						return false;
					}
				});
			})
		},
		CalcularTotalPorcentaje(Index){
			let SumaPorcentaje=0;
			this.PorcentajesPrograma.forEach(element => {
				SumaPorcentaje+=parseFloat(element.Porcentaje);
			});
			if (SumaPorcentaje>100) {
				this.$toast.warning('El Porcentaje Total no Puede ser Mayor a 100%');
				this.PorcentajesPrograma[Index].Porcentaje=0;
			}
		},
		AddPorcentajePredeterminado(){
			if (this.PorcentajesPrograma.length==0) {
				let ArrayNombres=[
					'Instalación Mecánica',
					'Instalación Eléctrica',
					'Instalación Control',
					'Montaje equipos',
					'Limpieza',
					'Trabajos civiles',
					'Acción de Seguridad',
					'Retrabajo',
					'Garantía',
					'Arranque',
					'Reunión Cliente',
					'Reunión Interno',
					'Ducteria',
					'Tubería Refrigeración',
					'Logística',
					'Movimiento e Izaje'
				];
				for (let index = 0; index < ArrayNombres.length; index++) {
					this.PorcentajesPrograma.push({IdProyectoPrograma:0,Porcentaje:0,Titulo:ArrayNombres[index],BndEdit:false});		
				}
			}
		},
		AddPorcentajePrograma(){
			if (this.PorcentajesPrograma.length<20) {
				this.PorcentajesPrograma.push({IdProyectoPrograma:0,Porcentaje:0,Titulo:'',BndEdit:true});	
			}
			else{
				this.$toast.warning('No se Pueden Agregar Más de 20 Elementos');
			}
		},
		DeletePorcentajePrograma(Index){
			this.$swal({
				title: "Esta seguro que desea eliminar este dato?",
				text: "No se podra revertir esta acción",
				type: "warning",
				showCancelButton: true,
				confirmButtonText: "Si",
				cancelButtonText: "No, mantener",
				showCloseButton: true,
				showLoaderOnConfirm: true
			}).then((result)=>{
				if (result.value){
					this.PorcentajesPrograma.splice(Index,1);
					// this.$toast.success('Información Eliminada');
				}
			})
		},
        async Guardar()
        {
            //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
            // this.Proyecto.Imagen = this.$refs.imagen.files[0];
			// VALIDAR LOS ELEMENTOS DEL PROGRAMA SI ES QUE TIENE
			let BndCancelar=false;
			let Mensaje='';
			let Contador=1;
			if (this.PorcentajesPrograma.length>0) {
				this.PorcentajesPrograma.forEach((Element) => {
					// if (Number(Element.Porcentaje)==0 || Element.Porcentaje=='') {
					// 	BndCancelar=true;
					// 	Mensaje='Se Debe Asignar un Porcentaje al Item '+Contador;
					// }
					if (Element.Titulo=='') {
						BndCancelar=true;
						Mensaje='Se Debe Asignar un Titulo al Item '+Contador;
					}
					Contador++;
				});
			}
			if (BndCancelar===true) {
				this.poBtnSave.disableBtn=false;
				this.$toast.warning(Mensaje);
				return false;
			}
            let formData = new FormData();
            let image=this.$refs.imagen.files[0];

            let FechaInicio='';
            if (this.Proyecto.FechaInicio!='' && this.Proyecto.FechaInicio!=undefined) {
                let day=this.Proyecto.FechaInicio.getDate();
                let month=this.Proyecto.FechaInicio.getMonth()+1;
                let year=this.Proyecto.FechaInicio.getFullYear();
                FechaInicio=year+'-'+month+'-'+day;   
            }
            let FechaFin='';
            if (this.Proyecto.FechaFin!='' && this.Proyecto.FechaFin!=undefined) {
                let day=this.Proyecto.FechaFin.getDate();
                let month=this.Proyecto.FechaFin.getMonth()+1;
                let year=this.Proyecto.FechaFin.getFullYear();
                FechaFin=year+'-'+month+'-'+day;   
            }

            formData.set('IdProyecto',this.Proyecto.IdProyecto);
            formData.set('Nombre',this.Proyecto.Nombre);
            formData.set('IdCliente', this.Proyecto.IdCliente);
            formData.set('IdClienteS',this.Proyecto.IdClienteS);
			formData.set('IdContrato',this.Proyecto.IdContrato);
			formData.set('Residente',this.Proyecto.Residente);
			formData.set('ContratosAditiva',JSON.stringify(this.Proyecto.ContratosAditiva));
            formData.set('Direccion',this.Proyecto.Direccion);
			formData.set('ProjectManager',this.Proyecto.ProjectManager);
			formData.set('IdProjectManager',this.Proyecto.IdProjectManager);
			formData.set('IdResidente',this.Proyecto.IdResidente);
			formData.set('Ciudad',this.Proyecto.Ciudad);
			formData.set('Estatus',this.Proyecto.Estatus);
            formData.set('Valor', this.Proyecto.Valor);
            formData.set('Latitud', this.oLatLng.Lat);
            formData.set('Longitud', this.oLatLng.Lng);
            formData.set('FechaInicio', FechaInicio);
            formData.set('FechaFin', FechaFin);
            formData.set('Imagen', this.Proyecto.Imagen);
			formData.set('UtilidadEstimada', this.Proyecto.UtilidadEstimada);
			formData.set('Fondo', this.Proyecto.Fondo);
			formData.set('Branch', this.Proyecto.Branch===false ? 0 : 1);
			formData.set('IdProyectoMaster', this.Proyecto.IdProyectoMaster);
			formData.set('IdContratoMaster', this.Proyecto.IdContratoMaster);
            formData.append('ImagenPrevio', image);
			formData.append('PorcentajesPrograma',JSON.stringify(this.PorcentajesPrograma));
			formData.append('PorcentajesProgramaAntiguo',JSON.stringify(this.PorcentajesProgramaAntiguo));
            
            await this.$http.post('proyectos/post',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
            ).then( (res) => {
                // sessionStorage.setItem("ocontacto",res.data.data.clientes);
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.poBtnSave.nombreModal).modal('hide');
                this.bus.$emit('List'); 
            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  
            });
        },
        Limpiar()
        {
            const  input  = this.$refs.imagen;
            input .type = 'text'
            input .type = 'file';
            this.AltLogoContacto=true;
            this.Proyecto={
                IdProyecto:0,
                IdEmpresa:"",
                IdSucursal:"",
                IdCliente:null,
                IdClienteS:null,
				IdContrato:null,
				ContratosAditiva:[],
                Nombre:"",
                Valor:"",
                Direccion:"",
				Ciudad:"",
				ProjectManager:"",
				Residente:"",
				Estatus:"",
                Latitud:"", 
                Longitud:"",
                FechaInicio:"",
                FechaFin:"",
                Imagen:"",
				ValorVenta:"",
				GrossProfit:'',
				UtilidadEstimada:'',
				Fondo:'',
				Branch:false,
				IdProyectoMaster:'',
				IdContratoMaster:'',
				IdProjectManager:'',
				IdResidente:''
            };
            this.oLatLng = {
				Lat: 19.43120339928868,
				Lng: -99.13450664719238
			};
			this.Contador=0;
            this.IdClienteS=null;
			this.IdContrato=null;
            this.errorvalidacion=[""];
            this.Ruta="";
			this.ListaContratosNormal=[];
			this.ListaContratosUsados=[];
			this.PorcentajesPrograma=[];
			this.PorcentajesProgramaAntiguo=[];
			this.ListProjectManager=[];
			this.ListResidente=[];
            // LIMPIAR LA IMAGEN
            $("#imagePreview").css('background-image','url()');
            $("#imagePreview").css('background-size','contain');
            // this.CorreoAntiguo='';
        },
        get_one()
        {
            this.ConfigLoad.ShowLoader=true;
            this.$http.get(
                this.urlApi,
                {
                    params:{IdProyecto: this.Proyecto.IdProyecto}
                }
            ).then( (res) => {
                const objres=res.data.data.proyecto
                this.Proyecto.IdProyecto =objres.IdProyecto;
                this.Proyecto.Nombre =objres.Nombre;
                this.Proyecto.Valor =objres.Valor;
                this.Proyecto.IdCliente =objres.IdCliente==0 ? null : objres.IdCliente;
                this.IdClienteS =objres.IdClienteS==0 ? null : objres.IdClienteS;
                this.Proyecto.IdEmpresa =objres.IdEmpresa;
                this.Proyecto.IdSucursal =objres.IdSucursal;
				this.IdContrato =objres.IdContrato==0 ? null : objres.IdContrato;
                this.Proyecto.Direccion =objres.Direccion;
				this.Proyecto.Ciudad =objres.Ciudad;
				this.Proyecto.Estatus =objres.Estatus;
				this.Proyecto.ProjectManager =objres.ProjectManager;
				this.Proyecto.Residente =objres.Residente;
				this.Proyecto.Branch=objres.Branch==0 ? false : true;
				this.Proyecto.IdProyectoMaster=objres.IdProyectoMaster;
				this.Proyecto.IdContratoMaster=objres.IdContratoMaster;
				this.Proyecto.IdProjectManager=objres.IdProjectManager;
				this.Proyecto.IdResidente=objres.IdResidente;
				this.Proyecto.UtilidadEstimada =parseFloat(objres.UtilidadEstimada).toFixed(0);
				this.Proyecto.Fondo =parseFloat(objres.Fondo).toFixed(0);
                this.oLatLng.Lat =parseFloat(objres.Latitud);
                this.oLatLng.Lng =parseFloat(objres.Longitud);
                let formatedDateInicio = objres.FechaInicio.replace(/-/g, "\/");
                this.Proyecto.FechaInicio=new Date(formatedDateInicio);
                let formatedDateFin = objres.FechaFin.replace(/-/g, "\/");
                this.Proyecto.FechaFin=new Date(formatedDateFin);
                // PARA RECUPERAR LA IMAGEN
                this.Ruta=res.data.data.ruta;
                this.Proyecto.Imagen=objres.Imagen;
                if (this.Proyecto.Imagen!='') {
                    $("#imagePreview").css('background-image','url('+this.Ruta+this.Proyecto.Imagen+')');
                    $("#imagePreview").css('background-size','contain');
                }
                if (this.Proyecto.Imagen=='' && this.Proyecto.IdCliente!=0) {
                    let IndexCliente=this.ListaClientesNormal.findIndex((element)=>element.IdCliente==this.Proyecto.IdCliente);
                    $("#imagePreview").css('background-image','url('+this.pRutaImagenCliente+this.ListaClientesNormal[IndexCliente].LogoCliente+')');
                    $("#imagePreview").css('background-size','contain');
                }
                this.ShowMap=true;
				this.AddPorcentajePredeterminado();
				//CHECAR PARA ASIGNAR TRUE O FALSE EN LA PROPIEDAD BNDEDIT
				let ArrayNombres=[
					'Instalación Mecánica',
					'Instalación Eléctrica',
					'Instalación Control',
					'Montaje equipos',
					'Limpieza',
					'Trabajos civiles',
					'Acción de Seguridad',
					'Retrabajo',
					'Garantía',
					'Arranque',
					'Reunión Cliente',
					'Reunión Interno',
					'Ducteria',
					'Tubería Refrigeración',
					'Logística',
					'Movimiento e Izaje'
				];
				this.PorcentajesPrograma=res.data.data.proyectoprograma;
				this.PorcentajesPrograma.forEach((value) => {
					if (ArrayNombres.includes(value.Titulo)) {
						value.BndEdit=false;
					}
					else{
						value.BndEdit=true;
					}
				});
				this.PorcentajesProgramaAntiguo=res.data.data.proyectoprogramaantiguo;
                // this.ConfigLoad.ShowLoader=false;
                // this.GetListaPropiedades();
            });
        },
        async GetListaClientes(){
            await this.$http.get("clientes/get"
			).then((res)=>{
                this.ListaClientesNormal=res.data.data.clientes;
				this.ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				});
                // if (this.Proyecto.IdProyecto>0) {
                //     this.GetListaPropiedades()
                // }
			});
        },
        async GetListaPropiedades(){
			if (this.Proyecto.IdCliente!=null) {
				if (this.Proyecto.IdProyecto>0) {
					if (this.Contador>=1) {
						this.Proyecto.IdClienteS=null;
						this.Proyecto.IdContrato=null;		
					}
				}
				else{
					this.Proyecto.IdClienteS=null;
					this.Proyecto.IdContrato=null;
				}
            	this.ListaPropiedadesNormal=[];
            	this.ListaPropiedades=[];
            	this.$http.get("clientesucursal/get",{
					params:{
						Todos:true,
						RegEstatus:'A',
						IdCliente:this.Proyecto.IdCliente
					}
				}
				).then((res)=>{
            	    this.ListaPropiedadesNormal=res.data.data.sucursal;
					this.ListaPropiedades=res.data.data.sucursal.map(function(obj){
						return {id:obj.IdClienteS,label:obj.Nombre}
					});
				}).finally(()=>{
					// if (Origen!='') {
					// 	this.GetListaContratos('recuperar');	
					// }
					if (this.Proyecto.IdProyecto>0 && this.Contador==0) {
            	        this.Proyecto.IdClienteS=this.IdClienteS;
						this.Proyecto.IdContrato=this.IdContrato;
            	    }
            	    if (this.Proyecto.IdProyecto>0 && this.Proyecto.Imagen=='') {
            	        this.ImagenPredeterminada();
            	    }
				});	
			}
        },
		async GetListaContratos(){
			if (this.Proyecto.IdClienteS!=null) {
				if (this.Proyecto.IdProyecto>0) {
					if (this.Contador>=1) {
						this.Proyecto.IdContrato=null;	
					}
				}
				else{
					this.Proyecto.IdContrato=null;
				}
				await this.$http.get(
					'numcontratoproyecto/get',
					{
						params:{IdClienteS:this.Proyecto.IdClienteS,IdConfigS:3}
					}
				).then( (res) => {
					let ContratosFiltrados=[];
					let ContratosProyectos=res.data.data.contratosusados;
					this.ListaContratosUsados=res.data.data.proyectos;
					if (ContratosProyectos.length>0) {
						if (this.Proyecto.IdContrato!=null) {
							ContratosFiltrados=res.data.data.row.filter((value) => {
								if (ContratosProyectos.includes(value.IdContrato) && this.Proyecto.IdContrato!=value.IdContrato) {
									return false;
								}
								else{
									return true;
								}
							});
						}
						else{
							ContratosFiltrados=res.data.data.row.filter((value) => {
								if (ContratosProyectos.includes(value.IdContrato)) {
									return false;
								}
								else{
									return true;
								}
							});
						}	
					}
					else{
						ContratosFiltrados=res.data.data.row;
					}
					this.ListaContratosNormal=ContratosFiltrados;
					this.ListaContratos =ContratosFiltrados.map(function(obj){
						return {id:obj.IdContrato,label:obj.NumeroC}
					});
					if (this.Contador<1) {
						let Filtro=this.ListaContratosUsados.filter((value) => {
							if (value.IdContrato!=this.Proyecto.IdContrato) {
								return true;
							}
							else{
								return false;
							}
						});
						this.ListaContratosUsados=Filtro;
						this.SeleccionContratoMontos();
					}
					this.Contador=1;
					// this.ListaContratosAditiva =res.data.data.row.map(function(obj){
					// 	return {id:obj.IdContrato,label:obj.NumeroC}
					// });
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				});	
			}
		},
        EliminarImagen(){
            if (this.$refs.imagen.files[0]!=undefined || this.Proyecto.Imagen!="") {
                this.$swal({
                title: 'Esta seguro que desea eliminar esta imagen?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        this.$toast.success('Información eliminada');
                        $("#imagePreview").css('background-image','url()');
                        $("#imagePreview").css('background-size','contain');
                        // console.log(this.$refs.logocliente.files);
                        this.$refs.imagen.value=null;
                        this.Proyecto.Imagen="";
                    } 
                });   
            }
            else{
                this.$toast.info('No hay una imagen para eliminar');
            }
        },
        CambiarImagen(event){
            this.$uploadImagePreview(event,this.ValidElement,Array('Img','imagePreview'));
        },
        ImagenPredeterminada(){
            $("#imagePreview").css('background-image','url()');
            $("#imagePreview").css('background-size','contain');
            if (this.$refs.imagen.value!=null) {
                $("#imagePreview").css('background-image','url('+this.Ruta+this.Proyecto.Imagen+')');
                $("#imagePreview").css('background-size','contain');
            }
            if (this.Proyecto.Imagen=='' && this.Proyecto.IdCliente!=null) {
                let IndexCliente=this.ListaClientesNormal.findIndex((element)=>element.IdCliente==this.Proyecto.IdCliente);
                $("#imagePreview").css('background-image','url('+this.pRutaImagenCliente+this.ListaClientesNormal[IndexCliente].LogoCliente+')');
                $("#imagePreview").css('background-size','contain');
                this.$refs.imagen.value=null
            }
            if (this.Proyecto.Imagen=='' && this.Proyecto.IdClienteS!=null) {
                let IndexCliente=this.ListaPropiedadesNormal.findIndex((element)=>element.IdClienteS==this.Proyecto.IdClienteS);
                if (this.ListaPropiedadesNormal[IndexCliente].LogoSucursal!='' && this.ListaPropiedadesNormal[IndexCliente].LogoSucursal!=null) {
                    let Imagen=this.ListaPropiedadesNormal[IndexCliente].LogoSucursal;
                    let ImageUrl=this.pRutaImagenPropiedad+this.Proyecto.IdClienteS+'/'+Imagen;
                    //CHECA SI LA IMAGEN EXISTE
                    var img = new Image();
                    img.src = ImageUrl;
                    if(img.height != 0){
                        $("#imagePreview").css('background-image','url('+this.pRutaImagenPropiedad+this.Proyecto.IdClienteS+'/'+Imagen+')');
                        $("#imagePreview").css('background-size','contain');
                        this.$refs.imagen.value=null
                    };
                    // var http = new XMLHttpRequest();
                    // http.open('HEAD', ImageUrl, false);
                    // http.send();
                    // if(http.status != 404){
                    //     $("#imagePreview").css('background-image','url('+this.pRutaImagenPropiedad+this.Proyecto.IdClienteS+'/'+Imagen+')');
                    //     $("#imagePreview").css('background-size','contain');
                    // }
                    // else{
                    //     return;
                    // }
                }
            }
        },
		SeleccionContrato(){
			let Index=this.ListaContratosNormal.findIndex((value) => value.IdContrato==this.Proyecto.IdContrato);
			if (Index!=-1){
				let formatedDate = this.ListaContratosNormal[Index].FechaInicio.replace(/-/g, "\/");
				this.Proyecto.FechaInicio=new Date(formatedDate);
				let formatedDate2 = this.ListaContratosNormal[Index].FechaTermino.replace(/-/g, "\/");
				this.Proyecto.FechaFin=new Date(formatedDate2);
			}
		},
		SeleccionContratoMontos(){
			let Index=this.ListaContratosNormal.findIndex((value) => value.IdContrato==this.Proyecto.IdContrato);
			if (Index!=-1){
				this.Proyecto.ValorVenta=this.ListaContratosNormal[Index].Valor;
				this.Proyecto.GrossProfit=this.ListaContratosNormal[Index].GrossProfit;
			}
		},
		SeleccionProyectoMaster(){
			let Index=this.ListaContratosUsados.findIndex((value) => value.IdContrato==this.Proyecto.IdContratoMaster);
			if (Index!=-1){
				this.Proyecto.IdProyectoMaster=this.ListaContratosUsados[Index].IdProyecto;
			}
		}
    },
    created() {
        this.GetListaClientes();
        this.bus.$off('NewModal_'+this.EmitSeccion);

        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {
            this.poBtnSave.disableBtn=false; 
            this.bus.$off('Save_'+this.EmitSeccion);
            this.bus.$on('Save_'+this.EmitSeccion,()=>
            {
                this.Guardar();
            });

            this.Limpiar();
			this.GetListPM();
            if (Id>0)
            {
                this.Proyecto.IdProyecto=Id;
                this.get_one();
            }
            else{
                this.ShowMap=true;
				this.AddPorcentajePredeterminado();
            }
            this.bus.$emit('Desbloqueo',false);
        });
        if (this.Id!=undefined)
        {
            this.Proyecto.IdProyecto=this.Id;
            this.get_one();
        }
    },
    computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
